import { useState, useContext } from "react"
import { gql, useQuery } from "@apollo/client"
import _ from "lodash"

import { DateTime } from "luxon"

// Context
import { UserContext } from "../context/userContext"
import OrganizationLogo from "../components/OrganizationLogo"

export default function StaffSidebar() {
  const userCtx = useContext(UserContext)
  const [staffData, setStaffData] = useState(null)
  const na = "N/A"

  const GET_STAFF = gql`
    query RecoveryPlanPage($staff_id: ID!, $organization_id: ID!) {
      user(staff_id: $staff_id, organization_id: $organization_id) {
        staff_id
        staff_phone_number
        staff_hire_date
        staff_role_name
        staff_primary_supervisor
        staff_primary_supervisor_name
      }
    }
  `
  useQuery(GET_STAFF, {
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
    },
    context: {
      headers: {
        //user: JSON.stringify(user),
      },
    },
    skip: !userCtx,
    fetchPolicy: "network-only",
    onCompleted: ({ user }) => {
      return setStaffData(user)
    },
  })

  return (
    <div className="sidebar">
      <OrganizationLogo />
      <div className="organization-container">
        <p>
          <strong>Staff Name:</strong>{" "}
          {` ${_.unescape(userCtx.session.user.staff_name_first)} ${_.unescape(
            userCtx.session.user.staff_name_last
          )} `}
        </p>
        <p>
          <strong>Date of Hire: </strong>{" "}
          {!_.isNull(staffData)
            ? DateTime.fromMillis(Number(staffData.staff_hire_date)).toISODate()
            : na}{" "}
        </p>
        <p>
          <strong>Staff ID:</strong> {` ${userCtx.session.user.staff_id}  `}{" "}
        </p>
        <p>
          <strong>Email: </strong>
          {` ${userCtx.session.user.staff_email_address}  `}{" "}
        </p>
        <p>
          <strong>Phone:</strong>{" "}
          {!_.isNull(staffData) ? staffData.staff_phone_number : na}{" "}
        </p>
        <p>
          <strong>Role: </strong>
          {!_.isNull(staffData) ? staffData.staff_role_name : na}{" "}
        </p>

        <p>
          <strong>Primary Supervisor: </strong>{" "}
          {!_.isNull(staffData) ? staffData.staff_primary_supervisor_name : na}{" "}
        </p>
      </div>
    </div>
  )
}
